import React from "react";
import Pagination from "@mui/material/Pagination";

const CommonPagination = ({
  count,
  page,
  onChange,
  totalItems,
  currentCount,
  itemLabel = "Items",
}) => {
  if (!count || count < 1) return null;

  return (
    <div className="pagination-bar">
      <div className="pagination-count-info">
        {totalItems > 0 && (
          <span>
            Showing {currentCount} of {totalItems} {itemLabel}
          </span>
        )}
      </div>
      <div className="pagination-container">
        <Pagination
          count={count}
          page={page}
          onChange={onChange}
          color="primary"
          variant="outlined"
          shape="rounded"
        />
      </div>
    </div>
  );
};

export default CommonPagination;
